var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    {
      staticClass: "btn-wishlist",
      attrs: {
        href: _vm.urlWishList,
        rel: "nofollow",
        "aria-label": _vm.$translate("Ceres::Template.wishList"),
      },
    },
    [
      _c(
        "svg",
        {
          staticClass: "header__svg",
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            width: "22",
            height: "22",
          },
        },
        [
          _c("use", {
            attrs: {
              "xmlns:xlink": "http://www.w3.org/1999/xlink",
              "xlink:href": "#svg-wishlist",
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c("span", { staticClass: "ml-1 d-none d-sm-inline wishlist-badge" }, [
        _vm._v(_vm._s(_vm.wishListCount)),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }